import React from 'react';

import { TWO_FACTOR_TYPE_OPTIONS } from '../constants';
import FormSelectInput from '../Components/Inputs/Form/FormSelectInput';
import { FormSectionTitle } from '../Components/Typography/Headlines';
import { Typography } from '@material-ui/core';
import ProfessionalPageWrapper from './Components/ProfessionalPageWrapper';

const TwoFactorAuth = ({permissions, record}) => {
    const { can_edit_two_factor_type } = permissions;
    const { helper_text_2fa } = record;

    return (
        <div>
            <FormSectionTitle title="Two Factor"/>
            <Typography gutterBottom>
                Two-Factor Authentication (2FA) is an additional layer of security on your VouchedFor account. Enabling
                2FA will require you to input a code, sent to you via email each time you log in.
            </Typography>

            <FormSelectInput
                style={{
                    marginTop: 16,
                    marginBottom: 16,
                }}
                source="two_factor_type"
                label="Two Factor Type"
                choices={TWO_FACTOR_TYPE_OPTIONS}
                disabled={!can_edit_two_factor_type}
                helperText={!can_edit_two_factor_type && helper_text_2fa}
            />
        </div>
    );
};

export default function TwoFactorAuthWrapper(props) {
    return (
        <ProfessionalPageWrapper {...props}>
            <TwoFactorAuth {...props} />
        </ProfessionalPageWrapper>
    );
};
